module.exports = __webpack_public_path__ + "static/media/wallet.18e75d99.svg";